import { ReactNode } from "react";
import { Drawer } from "antd";
import arrowRoundedLeft from "assets/svg/arrow-left-outline.svg";

export const SideDrawer = ({
  onClose,
  open,
  children,
  title,
  showNumber,
  numericVal,
  hideHeader,
  longer,
  placement = "right"
}: {
  onClose: () => void;
  open: boolean;
  children: ReactNode;
  title: string;
  showNumber?: boolean;
  numericVal?: number;
  hideHeader?: boolean;
  longer?: boolean;
  placement?: "left" | "right"
}) => {
  return (
    <Drawer
      destroyOnClose={true}
      width={longer ? 700 : 500}
      closeIcon={false}
      onClose={onClose}
      open={open}
      placement={placement}
    >
      {!hideHeader && (
        <div className={"flex gap-2 items-center border-b py-2"}>
          <img
            className={"cursor-pointer"}
            src={arrowRoundedLeft}
            alt={""}
            onClick={onClose}
          />
          <p className="text-xl font-semibold text-[#101828] font-grotesk">
            {title}{" "}
            {showNumber && (
              <span className="text-sm bg-[#EEEEEE] p-2 px-3 rounded-lg">
                {numericVal ? numericVal.toLocaleString() : 0}
              </span>
            )}
          </p>
        </div>
      )}

      <div className="py-2">{children}</div>
    </Drawer>
  );
};
